import { Link } from "react-router-dom";

const T = [["AK", 0, 0], ["ME", 0, 11], ["VT", 1, 10], ["NH", 1, 11], ["WA", 2, 1], ["ID", 2, 2], ["MT", 2, 3], ["ND", 2, 4], ["MN", 2, 5], ["IL", 2, 6], ["WI", 2, 7], ["MI", 2, 8], ["NY", 2, 9], ["RI", 2, 10], ["MA", 2, 11],
  ["OR", 3, 1], ["NV", 3, 2], ["WY", 3, 3], ["SD", 3, 4], ["IA", 3, 5], ["IN", 3, 6], ["OH", 3, 7], ["PA", 3, 8], ["NJ", 3, 9], ["CT", 3, 10],
  ["CA", 4, 1], ["UT", 4, 2], ["CO", 4, 3], ["NE", 4, 4], ["MO", 4, 5], ["KY", 4, 6], ["WV", 4, 7], ["VA", 4, 8], ["MD", 4, 9], ["DE", 4, 10],
  ["AZ", 5, 2], ["NM", 5, 3], ["KS", 5, 4], ["AR", 5, 5], ["TN", 5, 6], ["NC", 5, 7], ["SC", 5, 8], ["DC", 5, 9],
  ["OK", 6, 4], ["LA", 6, 5], ["MS", 6, 6], ["AL", 6, 7], ["GA", 6, 8], ["HI", 7, 0], ["TX", 7, 4], ["FL", 7, 9]];

export const StateGrid = ({ states = [] }) => {
  const by = Object.fromEntries(states.map(s => [s.code, s]));
  return (
    <div className="grid grid-cols-12 gap-1 sm:gap-1.5" data-testid="state-grid">
      {T.map(([c, r, col], i) => {
        const s = by[c] || { name: c, count: 0 };
        return (
          <Link key={c} to={`/directory/state/${c}`} title={`${s.name} · ${s.count} shops`} style={{ gridRow: r + 1, gridColumn: col + 1, animationDelay: `${i * 12}ms`, animationFillMode: "both" }}
            className={`aspect-square rounded-md sm:rounded-lg flex flex-col items-center justify-center transition-[transform,background-color] duration-200 hover:scale-110 hover:z-10 animate-in fade-in zoom-in-50 ${s.count ? "bg-amber-500 text-slate-900 hover:bg-amber-300" : "bg-slate-800 text-slate-300 hover:bg-blue-600 hover:text-white"}`} data-testid={`state-tile-${c}`}>
            <span className="text-[9px] sm:text-sm font-extrabold leading-none">{c}</span>
            {s.count > 0 && <span className="hidden sm:block text-[10px] font-semibold opacity-80 leading-none mt-1">{s.count}</span>}
          </Link>
        );
      })}
    </div>
  );
};
